"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundResponse = void 0;
class NotFoundResponse {
}
exports.NotFoundResponse = NotFoundResponse;
//# sourceMappingURL=not-found-response.js.map